import styled from "styled-components";
import paplo1 from "assets/images/pv_composition2.jpg";
import { fonts } from "styles";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  flex-grow: 0;
  scroll-snap-align: start;
`;

export const Content = styled.div`
  width: 100%;
  height: 100vh;
  overflow-y: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  &.left {
    flex: 1;
    background-color: white;
  }

  &.right {
    max-width: max-content;
  }
`;

export const PablloComposition = styled.img.attrs({ src: paplo1 })`
  object-fit: contain;
  width: 100%;
  height: 100%;
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: 470px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.h2`
  font-family: ${fonts.BentonSansWideBold};
  font-size: 56px;
  line-height: 56px;
  margin-bottom: 32px;
  text-align: center;
  color: black;
  text-transform: uppercase;
`;

export const Text = styled.article`
  width: 100%;
  max-width: 267px;
  font-family: ${fonts.BentonSansRegular};
  font-size: 15px;
  line-height: 20px;
  text-align: center;
  color: black;
  margin-bottom: 32px;
`;
